import { useState, useEffect, useMemo } from 'react'
import { isEmpty } from 'ui-seeker/utils'
import { ValidationError } from 'yup'


export default function useValidatorSeeker(dataSend, schema, validationDependencies=[]) {
    const [errors, setErrors] = useState({})

    useEffect(() => {
        try {
            schema.validateSync(dataSend, { abortEarly: false })
            setErrors({})
        } catch (err) {
            if (err instanceof ValidationError) {
                setErrors(err?.inner?.reduce((acc, error) => ({
                    ...acc,
                    [error.path]: error.message
                }), {}))
            } else throw err
        }
        // eslint-disable-next-line
    }, [JSON.stringify(dataSend), JSON.stringify(schema.describe()), ...validationDependencies])


    return useMemo(() => ({
        isValid: isEmpty(errors),
        errorRegistry: errors
        // eslint-disable-next-line
    }), [JSON.stringify(errors)])
}